import React from "react";

function HomeIn() {
  return (
    <div className="home">
      <div class="container">
        <div class="row align-items-center my-5">
          <div class="col-lg-5">
            <h1 class="title">Home</h1>
            <header className="21 Days">
                <p class="center">
                    Here are your goals today: HI
                </p>
            </header>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HomeIn;